import { EquipmentItemTypeSchema } from '@standandforce/api-contract';
import { z } from 'zod';
import { EquipmentStatusSchema } from '@/features/equipment/-constants';
export const equipmentListFilterFields = {
  status: EquipmentStatusSchema.default('ALL'),
  freeText: z.string().optional(),
  equipmentTypeIdIn: z.array(z.string()).optional(),
  equipmentItemIdIn: z.array(z.string()).optional(),
  itemTypeIn: z.array(EquipmentItemTypeSchema).optional(),
  placementPlaceIdIn: z.array(z.string()).optional(),
  warehousingPlaceIdIn: z.array(z.string()).optional()
};